<template>
  <div class="pronoun-filter d-flex justify-content-center">
    <!-- Dropdown button for mobile -->
    <div class="dropdown d-lg-none">
      <button
        class="btn btn-info dropdown-toggle fw-bold"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {{ selectedPronounText }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li
          v-for="(pronoun) in pronouns"
          :key="pronoun.es"
          class="dropdown-item"
          :class="{ 'bg-info fw-bold': modelValue === pronoun.es }"
          style="cursor: pointer;"
          @click="selectPronoun(pronoun.es)"
        >
          {{ pronoun.en }} / {{ pronoun.es }}
        </li>
      </ul>
    </div>

    <!-- Button for desktop view -->
    <button
      v-for="(pronoun) in pronouns"
      :key="pronoun.es"
      :class="[
        'btn btn-sm',
        'btn-outline-info fw-bold d-none d-lg-inline-block',
        { active: modelValue === pronoun.es },
      ]"
      @click="selectPronoun(pronoun.es)"
    >
      {{ pronoun.en }} / {{ pronoun.es }}
    </button>
  </div>
</template>

<script>
export default {
  name: "PronounFilter",
  props: {
    modelValue: {
      type: String,
      default: "yo",
    },
  },
  computed: {
    pronouns() {
      return [
        { en: "I", es: "yo" },
        { en: "You", es: "tú" },
        { en: "He/She", es: "él" },
        { en: "We", es: "nosotros" },
        { en: "You (plural)", es: "vosotros" },
        { en: "They", es: "ellos" },
      ];
    },
    selectedPronounText() {
      // Find the selected pronoun text for the dropdown button
      const selected = this.pronouns.find(
        (pronoun) => pronoun.es === this.modelValue
      );
      return selected ? `${selected.en} / ${selected.es}` : "";
    },
  },
  methods: {
    selectPronoun(pronoun) {
      this.$emit("update:modelValue", pronoun);
    },
  },
};
</script>
